<template>
  <div class="">
    <div class="flex flex-wrap items-center justify-between"></div>
    <b-modal
      ref="modal-siparisDetay"
      id="modal-primary"
      modal-class="modal-primary"
      centered
      title="Sipariş Detay"
      size="xl"
      hide-footer
    >
      <b-row align-h="end">
        <b-col cols="2" style="    text-align: -webkit-right;">
          <div class="flex items-center">
            <vs-button
              @click="yazdir()"
              type="gradient"
              icon-pack="feather"
              icon="icon icon-download"
              color="danger"
              style="border-radius: 5px"
              size="small"
              >İndir/Yazdır</vs-button
            >
          </div></b-col
        >
      </b-row>
      <div id="printMe23">
        <b-row>
          <b-col cols="6">
            <vs-card>
              <div
                slot="header"
                style="padding: 0px !important; padding-bottom: 0px !important;"
              >
                <b-col cols="12" align-self="center">
                  <b-row align-h="start">
                    <b-col
                      cols="12"
                      align-self="center"
                      style="margin-bottom: 10px"
                    >
                      <vs-chip color="primary">
                        {{ orderNumber }}
                      </vs-chip>
                    </b-col>
                    <b-col align-self="center">
                      <blockquote
                        style="padding-left: 15px;
                        border-left: 4px solid #7367f0;
                      "
                      >
                        <b-row v-if="invoiceFirstName != ''">
                          <b-col cols="12" md="auto" align-self="center"
                            ><h6 class="text-primary">
                              Sipariş Tarihi:
                            </h6></b-col
                          >
                          <b-col cols="12" md="auto" align-self="center">
                            <h6>
                              {{ siparisTarihi }}
                            </h6>
                          </b-col>
                        </b-row>
                        <b-row v-if="invoiceFirstName != ''">
                          <b-col cols="12" md="auto" align-self="center"
                            ><h6 class="text-primary">
                              Sipariş Cari Adı:
                            </h6></b-col
                          >
                          <b-col cols="12" md="auto" align-self="center">
                            <h6>
                              {{ invoiceFirstName }}
                            </h6>
                          </b-col>
                        </b-row>
                        <b-row v-if="invoiceLastName != ''">
                          <b-col cols="12" md="auto" align-self="center"
                            ><h6 class="text-primary">
                              Sipariş Cari Soyadı:
                            </h6></b-col
                          >
                          <b-col cols="12" md="auto" align-self="center">
                            <h6>
                              {{ invoiceLastName }}
                            </h6>
                          </b-col>
                        </b-row>
                      </blockquote>
                    </b-col>
                  </b-row>
                </b-col>
              </div>
            </vs-card>
          </b-col>
          <b-col cols="6">
            <vs-card>
              <div
                slot="header"
                style="padding: 0px !important; padding-bottom: 0px !important;"
              >
                <b-col cols="12" align-self="center">
                  <b-row align-h="start">
                    <b-col align-self="center">
                      <blockquote
                        style="padding-left: 15px; border-left: 4px solid #7367f0;"
                      >
                        <b-row v-if="customerEmail != ''">
                          <b-col cols="12" md="auto" align-self="center"
                            ><h6 class="text-primary">
                              Sipariş Cari Mail:
                            </h6></b-col
                          >
                          <b-col cols="12" md="auto" align-self="center">
                            <h6>
                              {{ customerEmail }}
                            </h6>
                          </b-col>
                        </b-row>
                        <b-row v-if="telefon != ''">
                          <b-col cols="12" md="auto" align-self="center"
                            ><h6 class="text-primary">
                              Sipariş Cari Telefon:
                            </h6></b-col
                          >
                          <b-col cols="12" md="auto" align-self="center">
                            <h6>
                              {{ telefon }}
                            </h6>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col cols="12" md="auto" align-self="center"
                            ><h6 class="text-primary">
                              Fatura Adresi:
                            </h6></b-col
                          >
                          <b-col cols="12" md="auto" align-self="center">
                            <h6>
                              {{ invoiceAddress1 }} /
                              {{
                                invoiceAddress2 != invoiceAddress1
                                  ? invoiceAddress2
                                  : ""
                              }}
                              / {{ invoiceCity }} /{{ invoiceDistrict }}
                            </h6>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col cols="12" md="auto" align-self="center"
                            ><h6 class="text-primary">
                              Teslimat Adresi:
                            </h6></b-col
                          >
                          <b-col cols="12" md="auto" align-self="center">
                            <h6>
                              {{ shipAddress1 }} /
                              {{
                                shipAddress2 == shipAddress1 ? "" : shipAddress2
                              }}
                              / {{ shipCity }} / {{ shipDistrict }}
                            </h6>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col cols="12" md="auto" align-self="center"
                            ><h6 class="text-primary">
                              Vergi Bilgileri:
                            </h6></b-col
                          >
                          <b-col cols="12" md="auto" align-self="center">
                            <h6>{{ taxOffice }} / {{ taxNumber }}</h6>
                          </b-col>
                        </b-row>
                      </blockquote>
                    </b-col>
                  </b-row>
                </b-col>
              </div>
            </vs-card>
          </b-col>
        </b-row>

        <vs-card
          style="padding-right: 20px; margin-bottom: 5px !important; font-size: 15px;"
        >
          <b-row
            style="margin-bottom: 0px !important; padding-bottom: 0px !important; font-size: small;"
          >
            <b-col style=" text-decoration: underline;color: #EA5455;" cols="2"
              >Stok Adı</b-col
            >
            <b-col style=" text-decoration: underline;color: #EA5455;" cols="2"
              >Stok Kodu</b-col
            >
            <b-col style=" text-decoration: underline;color: #EA5455;" cols="2"
              >Barkod</b-col
            >
            <b-col style=" text-decoration: underline;color: #EA5455;" cols="2"
              >Adet</b-col
            >
            <b-col style=" text-decoration: underline;color: #EA5455;" cols="2"
              >Fiyat</b-col
            >
            <b-col style=" text-decoration: underline;color: #EA5455;" cols="2"
              >Tutar</b-col
            >
          </b-row>
        </vs-card>
        <div :class="scrollview">
          <div v-for="(item, index) in productDetail" :key="index">
            <vs-card style="margin-bottom: 5px !important; font-size: 14px;">
              <b-row align-v="center" style="font-size: small;">
                <b-col cols="2">
                  <div style="overflow-wrap: anywhere;">
                    {{ item.productName }}
                  </div>
                </b-col>
                <b-col cols="2">
                  <div style="overflow-wrap: anywhere;">
                    {{
                      item.productCode == 0
                        ? item.merchantSku
                        : item.productCode
                    }}
                  </div>
                </b-col>
                <b-col cols="2">
                  <div style="overflow-wrap: anywhere;">
                    {{ item.barcode }}
                  </div>
                </b-col>
                <b-col cols="2">
                  <div style="overflow-wrap: anywhere;">
                    {{ item.quantity }}
                  </div>
                </b-col>
                <b-col cols="2">
                  <div style="overflow-wrap: anywhere;">
                    {{ currencyFormatter(item.price, "₺") }}
                  </div>
                </b-col>

                <b-col cols="2">
                  <div style="overflow-wrap: anywhere;">
                    {{ currencyFormatter(item.amount, "₺") }}
                  </div>
                </b-col>
              </b-row>
              {{ item.xmlDetayLis }}
              <vs-divider v-if="item.xmlDetayList[0] != null"></vs-divider>
              <div :class="scrollview">
                <b-row>
                  <b-col cols="12">
                    <vs-table
                      v-if="item.xmlDetayList[0] != null"
                      :data="item.xmlDetayList[0]"
                    >
                      <template slot="thead">
                        <vs-th sort-key="firma">Firma</vs-th>
                        <vs-th sort-key="stokName">Stok Adı</vs-th>
                        <vs-th sort-key="stokKodu">Stok Kodu</vs-th>
                        <vs-th sort-key="adet">Adet</vs-th>
                        <vs-th sort-key="quantity">Fiyat</vs-th>
                        <vs-th sort-key="kampanyaAdet">Kampanya Adet</vs-th>
                        <vs-th sort-key="kampanyaFiyat">Kampanya Fiyat</vs-th>
                        <vs-th sort-key="durum">Durum</vs-th>
                        <vs-th sort-key="gonderimTarihi">Gönderim Tarihi</vs-th>
                        <vs-th sort-key="quantity">Gönder</vs-th>
                      </template>

                      <template slot-scope="{ data }">
                        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                          <vs-td :data="data[indextr].firma">
                            {{ data[indextr].firma }}
                          </vs-td>
                          <vs-td :data="data[indextr].stokName">
                            {{ data[indextr].stokName }}
                          </vs-td>
                          <vs-td :data="data[indextr].stokKodu">
                            {{ data[indextr].stokKodu }}
                          </vs-td>

                          <vs-td :data="data[indextr].adet">
                            {{ data[indextr].adet }}
                          </vs-td>

                          <vs-td :data="data[indextr].quantity">
                            {{
                              currencyFormatter(
                                data[indextr].fiyat,
                                data[indextr].doviz == "USD"
                                  ? "$"
                                  : data[indextr].doviz == "EUR"
                                  ? "€"
                                  : "₺"
                              )
                            }}
                          </vs-td>
                          <vs-td :data="data[indextr].kampanyaAdet">
                            {{ data[indextr].kampanyaAdet }}
                          </vs-td>
                          <vs-td :data="data[indextr].kampanyaFiyat">
                            {{
                              data[indextr].kampanyaFiyat == null
                                ? ""
                                : currencyFormatter(
                                    data[indextr].kampanyaFiyat,
                                    data[indextr].doviz == "USD"
                                      ? "$"
                                      : data[indextr].doviz == "EUR"
                                      ? "€"
                                      : "₺"
                                  )
                            }}
                          </vs-td>

                          <vs-td :data="data[indextr].durum">
                            <vs-chip
                              color="success"
                              v-if="data[indextr].durum == 'Aktif'"
                            >
                              {{ data[indextr].durum }}
                            </vs-chip>
                            <vs-chip
                              color="danger"
                              v-else-if="data[indextr].durum == 'Iptal'"
                            >
                              {{ data[indextr].durum }}
                            </vs-chip>
                            <vs-chip
                              color="warning"
                              v-else-if="data[indextr].durum == 'Tamamlandı'"
                            >
                              {{ data[indextr].durum }}
                            </vs-chip>
                          </vs-td>
                          <vs-td :data="data[indextr].gonderimTarihi">
                            {{
                              data[indextr].gonderimTarihi == null
                                ? ""
                                : parseDate(data[indextr].gonderimTarihi)
                            }}
                          </vs-td>

                          <vs-td>
                            <b-button
                              variant="outline-light"
                              @click="tedarikcidenIste(item, data[indextr])"
                              size="sm"
                              ><Icon
                                icon="carbon:scis-transparent-supply"
                                width="20"
                                height="20"
                                v-b-tooltip.hover.bottom="'Tedarikçiden iste'"
                                color="#7367F0"
                            /></b-button>
                          </vs-td>
                        </vs-tr>
                      </template> </vs-table
                  ></b-col>
                </b-row>
              </div>
            </vs-card>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal
      ref="modal-tedarikciTarihi"
      id="modal-primary"
      modal-class="modal-primary"
      centered
      title="Tedarikçiden İste"
      size="md"
      hide-footer
    >
      <div style="min-height: 350px">
        <vs-card>
          <div>
            <b-row>
              <b-col>
                <b-form-group label="Tedarikçi Tarihi" label-for="item-name"
                  ><b-form-datepicker
                    id="tedarikciTarihi"
                    v-model="tedarikciTarihi"
                    size="md"
                    local="en"
                    class="mb-2"
                    today-variant="success"
                    placeholder="-"
                    :date-format-options="{
                      year: 'numeric',
                      month: 'numeric',
                      day: 'numeric'
                    }"/></b-form-group
              ></b-col>
            </b-row>
          </div>

          <div slot="footer">
            <vs-row vs-justify="flex-end">
              <b-button
                style="background-color: #28C76F; border-color:#28C76F;"
                v-on:click="tedarikciyeGonder()"
                ><Icon
                  style="margin-right: 5px"
                  icon="mdi:content-save-check-outline"
                  width="20"
                  height="20"
                  v-b-tooltip.hover.bottom="'Kampanya oluştur'"
                />Kaydet</b-button
              >
            </vs-row>
          </div>
        </vs-card>
      </div>
    </b-modal>
  </div>
</template>
<script>
//import { defineComponent } from "@vue/composition-api";
import VueBarcode from "vue-barcode";
import Store from "../../../../store/store";
import state from "../../../../store/state";
import { Icon } from "@iconify/vue2";
import moment from "moment";
export default {
  name: "SiparisDetayButton",
  props: [],
  //[ pazaryerData=[], "orderNumber", "invoiceFirstName", "invoiceLastName", "shipFullName"],

  data() {
    return {
      paramSecilen: [],
      xmlParamSecilen: [],
      tedarikciTarihi: "",
      scrollview: "",
      taxOffice: "",
      shipAddress1: "",
      shipAddress2: "",
      invoiceAddress1: "",
      invoiceAddress2: "",
      siparisTarihi: "",

      taxNumber: "",
      merchantSku: "",
      invoiceFirstName: "",
      invoiceLastName: "",
      barcodeValue: "",
      orderNumber: "",
      program: "",
      productDetail: [],

      shipFullAddress: "",
      shipFullName: "",
      shipCity: "",
      shipDistrict: "",

      quantityPrice: 0,
      grossAmount: 0,
      totalDiscount: 0,
      totalPrice: 0,

      invoiceFullAddress: "",
      invoiceFullName: "",
      telefon: 0,
      customerEmail: "",

      cargoProviderName: "",
      cargoTrackingNumber: "",
      discount: 0,

      mailTo: "",
      invoiceDistrict: "",
      invoiceCity: "",

      viewCheck: false,
      popupKartDetay: false,
      musteriId: "",
      imageSrc: "",
      serialNumber: "",
      productValue: []
    };
  },
  created() {
    this.musteriId = Store.state.MusteriId;
    this.scrollview = "scroll-hand";
    // this.imageSrc = "../../assets/images/logo/" + this.musteriId + ".png";
  },
  methods: {
    siparisDurumGuncelle() {
      var vm = this;
      var vs = this.$vs;

      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        pazarYeri: "Ticimax",
        orderNumber: vm.orderNumber,
        sipDurum: "5"
      };

      soap.createClient(url, function(err, client) {
        client.siparisDurumGuncelle(args, function(err, result) {
          if (result.siparisDurumGuncelleResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler2 = JSON.parse(result.siparisDurumGuncelleResult);
            vs.notify({
              title: "Tedarikçi",
              text: "Durum güncellemesi başarılı",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
              position: "top-center"
            });
          } catch (error) {
            console.log(error);
            vs.notify({
              title: "Tedarikçi",
              text: "Durum güncellemesinde hata oluştu",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center"
            });
          }
        });
      });
    },
    tedarikciyeGonder() {
      var vm = this;
      var vs = this.$vs;

      const soap = require("soap");
      const url = state.sistemAddress;
      if (vm.tedarikciTarihi == "") {
        vs.notify({
          text: "Tedarikçi tarihi girilmelidir",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center"
        });
      } else {
        const args = {
          token: Store.state.tokenId,
          orderNumber: vm.orderNumber,
          tedarikciBarkod: vm.xmlParamSecilen.barkod,
          pazaryerBarkod: vm.paramSecilen.barcode,
          gonderimTarihi: vm.tedarikciTarihi,
          tedarikci: vm.xmlParamSecilen.firma,
          durum: "Aktif",
          orderId: vm.paramSecilen.Id
        };
        soap.createClient(url, function(err, client) {
          client.xmlSiparis(args, function(err, result) {
            if (result.xmlSiparisResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            }
            vm.veriler = JSON.parse(result.xmlSiparisResult);
            if (vm.veriler.response == "Ok") {
              vs.notify({
                text: "Tedarikçi işlemi başarılı",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center"
              });
              vm.siparisDetayGet();
              vm.siparisDurumGuncelle();
              vm.$refs["modal-tedarikciTarihi"].hide();
              vm.tedarikciTarihi = "";
              vm.$root.$emit("xmlTicimaxSiparisListele");
            } else {
              vs.notify({
                text: "Tedarikçi işleminde hata oluştu",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center"
              });
            }
          });
        });
      }
    },
    parseDate(params) {
      return moment(String(params)).format("DD.MM.YYYY");
    },
    tedarikcidenIste(param, paramXml) {
      this.$refs["modal-tedarikciTarihi"].show();
      this.paramSecilen = param;

      this.xmlParamSecilen = paramXml;
    },
    currencyFormatter(currency, sign) {
      var gelencurr = parseFloat(currency);
      var sansDec = gelencurr.toFixed(2);
      var formatted = sansDec.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return sign + `${formatted}`;
    },
    handscroll(el) {},
    print() {
      // Pass the element id here
      this.$htmlToPaper("printMe23");
    } /*
    findLogo() {
      return require("../../../../assets/images/logo/" +
        this.musteriId +
        ".png");
    },*/,
    yazdir() {
      setTimeout(this.yazdirBekle, 1000);
    },
    yazdirBekle() {
      this.$htmlToPaper("printMe23");
    },
    getNow: function() {
      const today = new Date();
      const date =
        today.getDate() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getFullYear();
      const time =
        today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      const dateTime = date + " " + time;
      return dateTime;
    },
    printInvoice() {
      window.print();
    },
    siparisDetayGet() {
      var vm = this;
      vm.productDetail = [];
      vm.invoiceFirstName = vm.productValue[0].invoiceFirstName;
      vm.invoiceLastName = vm.productValue[0].invoiceLastName;
      vm.merchantSku = vm.productValue[0].merchantSku;
      vm.orderNumber = vm.productValue[0].orderNumber;

      vm.veriler = [];
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        program:
          typeof vm.productValue[0].program == "undefined"
            ? vm.program
            : vm.productValue[0].program,
        orderNumber: vm.productValue[0].orderNumber
      };
      soap.createClient(url, function(err, client) {
        client.SiparisDetay(args, function(err, result) {
          if (result.SiparisDetayResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.SiparisDetayResult);
          vm.customerEmail = vm.veriler[0].customerEmail;
          vm.telefon = vm.veriler[0].telefon;
          vm.customerFirstName = vm.veriler[0].customerFirstName;
          vm.customerLastName = vm.veriler[0].customerLastName;
          vm.invoiceAddress1 = vm.veriler[0].invoiceAddress1;
          vm.invoiceAddress2 = vm.veriler[0].invoiceAddress2;
          vm.invoiceCity = vm.veriler[0].invoiceCity;
          vm.invoiceDistrict = vm.veriler[0].invoiceDistrict;
          vm.shipAddress1 = vm.veriler[0].shipAddress1;
          vm.shipAddress2 = vm.veriler[0].shipAddress2;
          vm.shipCity = vm.veriler[0].shipCity;
          vm.shipDistrict = vm.veriler[0].shipDistrict;
          vm.siparisTarihi = vm.veriler[0].siparisTarihi;
          vm.taxOffice = vm.veriler[0].taxOffice;
          vm.taxNumber = vm.veriler[0].taxNumber;
          vm.veriler.forEach((value, i) => {
            vm.productDetail.push({
              Id: value.Id,
              barcode: value.barcode,
              productCode: value.productCode,
              merchantSku: value.merchantSku,
              productName: value.productName,
              quantity: value.quantity,
              price: value.price,
              amount: value.amount,
              xmlDetayList: []
            });
            if (vm.productDetail[i].quantity > 1) {
              for (
                let index = 0;
                index < vm.productDetail[i].quantity;
                index++
              ) {
                vm.quantityPrice += vm.productDetail[i].price;
              }
            } else {
              vm.quantityPrice = vm.productDetail[i].price;
            }
            vm.totalPrice += value.price;
          });
          vm.XmlStokListDetay(0);
        });
      });
    },
    siparisDetayCek(productValue, program) {
      var vm = this;
      vm.productDetail = [];
      vm.totalPrice = 0;
      vm.quantityPrice = 0;
      vm.productValue = productValue;
      vm.program = program;
      vm.$refs["modal-siparisDetay"].show();
      vm.siparisDetayGet();
      // vm.popupKartDetay = true;
    },
    XmlStokListDetay(indexFunc) {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;

      if (typeof vm.productDetail[indexFunc] != "undefined") {
        const args = {
          barcode: vm.productDetail[indexFunc].barcode,
          orderNumber: vm.orderNumber,
          orderId: vm.productDetail[indexFunc].Id
        };

        soap.createClient(url, function(err, client) {
          client.XmlStokListDetay(args, function(err, result) {
            if (result.XmlStokListDetayResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            }
            try {
              vm.veriler2 = JSON.parse(result.XmlStokListDetayResult);
              vm.productDetail[indexFunc].xmlDetayList.push(
                vm.veriler2.jsonData
              );
              indexFunc++;
              vm.XmlStokListDetay(indexFunc);
            } catch (error) {}
          });
        });
      }
    }
  },

  components: {
    Icon,
    "v-barcode": VueBarcode
  },
  mounted() {
    this.$emit("setAppClasses", "invoice-page");
  }
  // mounted(){this.siparisDetay()}
};
</script>
<style lang="scss">
.scroll-hand {
  max-height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
}
.con-vs-popup .vs-popup {
  width: 850px;
}
.vs-table--tbody-table {
  min-width: 0px;
}
@media print {
  .invoice-page {
    * {
      visibility: hidden;
    }

    #content-area {
      margin: 0 !important;
    }

    .vs-con-table {
      .vs-con-tbody {
        overflow: hidden !important;
      }
    }

    #invoice-container,
    #invoice-container * {
      visibility: visible;
    }
    #invoice-container {
      position: absolute;
      left: 0;
      top: 0;
      box-shadow: none;
    }
  }
}

@page {
  size: auto;
}
</style>
